module.exports = __webpack_public_path__ + "img/mini_logo.b6c3637d.png";